import GoogleMapsApiLoader from 'google-maps-api-loader';

const loadGoogleMapsApi = async (googleApiKey) =>
  new Promise((resolve) =>
    GoogleMapsApiLoader({
      apiKey: googleApiKey,
      libraries: ['places'],
    }).then((result) => resolve(result))
  );

export default loadGoogleMapsApi;
